import Splide from '@splidejs/splide';

const EL = '.js-card-slider-gift';

document.querySelectorAll('.js-card-slider-gift').forEach((carousel) => {
  const slider = new Splide(carousel, {
    arrows: false,
    pagination: false,
    gap: 30,
    perPage: 4,
    breakpoints: {
      1366: {
        gap: 30,
        perPage: 3,
        pagination: true,
      },
      1024: {
        perPage: 2,
      },
      767: {
        gap: 10,
        perPage: 1,
      },
    },
  });

  slider.mount();
});
